
import React from 'react';
import { Lead } from '@/components/leads/types';
import { EditableDetailItem } from '../EditableDetailItem';
import { MessageSquare } from 'lucide-react';

interface NotesSectionProps {
  lead: Lead;
  handleFieldSave: (leadId: string, fieldName: keyof Lead, value: any) => Promise<void>;
  isUpdatingLead: boolean;
}

export const NotesSection: React.FC<NotesSectionProps> = ({ lead, handleFieldSave, isUpdatingLead }) => {
  return (
    <div className="pt-4">
      <h3 className="text-md font-semibold mb-3 text-gray-800 flex items-center"><MessageSquare size={18} className="mr-2 text-primary"/>Notes</h3>
      <EditableDetailItem
        icon={null} 
        label=""
        value={lead.notes}
        fieldName="notes"
        leadId={lead.id}
        onSave={handleFieldSave}
        inputType="textarea"
        className="items-start"
        displayFormatter={(val) => <div className="prose prose-sm max-w-none whitespace-pre-wrap text-gray-900">{val || 'N/A'}</div>}
        isLoading={isUpdatingLead}
      />
    </div>
  );
};
